document.addEventListener('DOMContentLoaded', function () {

    if (typeof window !== 'undefined') {
        if (!window.crypto) window.crypto = {};

        if (!window.crypto.randomUUID) {
            window.crypto.randomUUID = function () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    const r = Math.random() * 16 | 0;
                    const v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            };
        }
    }

    function getSportsBetslip(){

        const containerWsdk = document.querySelector('.sportsbook .altenar-wsdk-container');
        if (containerWsdk) {
            if (!window.altenarWSDK) {
                console.error('Altenar WSDK is not loaded.');
                return;
            }

            const initialHash = window.location.hash;
            const initialRoute = initialHash ? initialHash.replace('#/', '').replace('#', '') : null;

            const initOptions = {
                integration: sportsbookData.integration,
                culture: sportsbookData.culture,
                token: sportsbookData.token,
            };

            window.altenarWSDK.init(initOptions);

            const sbOptions = {
                props: {
                    ...(sportsbookData.page && {page: sportsbookData.page}),
                    ...(sportsbookData.championship_ids && {championshipIds: [parseInt(sportsbookData.championship_ids, 10)]}),
                    ...(sportsbookData.category_ids && {categoryIds: [parseInt(sportsbookData.category_ids, 10)]}),
                    ...(sportsbookData.sport_id && {sportId: parseInt(sportsbookData.sport_id, 10)}),
                    // Pass the initial route if it exists
                    ...(initialRoute && {page: initialRoute}),
                },
                container: containerWsdk,
            }
            window.ASB = window.altenarWSDK.addSportsBook(sbOptions);

            setTimeout(function () {
                const hasTouch =
                    'ontouchstart' in window || navigator.maxTouchPoints > 0;

                const maxSide = Math.max(window.innerWidth, window.innerHeight);
                const isMobileOrTablet = hasTouch && maxSide <= 1100;

                if (!isMobileOrTablet) return;

                const sportsbook = document.querySelector('.sportsbook');
                if (!sportsbook) return;

                let overlay = document.getElementById('wbetslip-overlay');
                if (!overlay) {
                    overlay = document.createElement('div');
                    overlay.id = 'wbetslip-overlay';
                    document.body.appendChild(overlay);
                }

                let container = document.getElementById('wbetslip-container');
                if (!container) {
                    container = document.createElement('div');
                    container.id = 'wbetslip-container';
                    container.className = 'wbetslip-container';
                    container.setAttribute('role', 'dialog');
                    container.setAttribute('aria-hidden', 'true');
                    container.setAttribute('aria-modal', 'true');

                    const closeBtn = document.createElement('button');
                    closeBtn.className = 'wbetslip-close-btn';
                    closeBtn.setAttribute('aria-label', 'Close bet slip');
                    closeBtn.innerHTML = '<i class="fa fa-xmark" aria-hidden="true"></i>';
                    container.appendChild(closeBtn);

                    const content = document.createElement('div');
                    content.className = 'wbetslip-modal-content';
                    content.id = 'wbetslip-modal-content';
                    container.appendChild(content);

                    document.body.appendChild(container);

                    closeBtn.addEventListener('click', function (e) {
                        e.stopPropagation();
                        closeWBetSlip();
                    });
                }

                function ensureBetSlipCountEl() {
                    const betslipLink = document.querySelector('.betslip');
                    if (!betslipLink) return null;

                    let countEl = betslipLink.querySelector('i.count');
                    if (!countEl) {
                        countEl = document.createElement('i');
                        countEl.className = 'count';
                        betslipLink.appendChild(countEl);
                    }

                    return countEl;
                }

                function updateBetSlipCount(count) {
                    const countEl = ensureBetSlipCountEl();
                    if (!countEl) return;

                    if (count > 0) {
                        countEl.textContent = count;
                        countEl.style.display = '';
                    } else {
                        countEl.textContent = '';
                        countEl.style.display = 'none';
                    }
                }

                function openWBetSlip() {
                    overlay.classList.add('open');
                    container.classList.add('open');
                    container.setAttribute('aria-hidden', 'false');
                    document.documentElement.style.overflow = 'hidden';
                    document.body.style.overflow = 'hidden';
                }

                function closeWBetSlip() {
                    overlay.classList.remove('open');
                    container.classList.remove('open');
                    container.setAttribute('aria-hidden', 'true');
                    document.documentElement.style.overflow = '';
                    document.body.style.overflow = '';
                }

                function toggleWBetSlip() {
                    if (container.classList.contains('open')) {
                        closeWBetSlip();
                    } else {
                        openWBetSlip();
                    }
                }

                const contentEl = document.getElementById('wbetslip-modal-content');
                if (window.altenarWSDK && contentEl) {
                    contentEl.innerHTML = '';

                    window.altenarWSDK.addWidget({
                        widget: 'WBetSlip',
                        props: {
                            betTypes: [0, 1, 2],
                            onSelectionCountChange: function (count) {
                                updateBetSlipCount(count);
                            }

                        },
                        container: contentEl,
                        expand: false
                    });
                }

                window.toggleWBetSlip = toggleWBetSlip;
                window.openWBetSlip = openWBetSlip;
                window.closeWBetSlip = closeWBetSlip;

                const betslipButton = document.querySelector('.mobile-nav-link.betslip');
                if (betslipButton) {
                    betslipButton.addEventListener('click', function (e) {
                        toggleWBetSlip();
                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    });
                }

                overlay.addEventListener('click', function (e) {
                    closeWBetSlip();
                    e.preventDefault();
                    return false;
                });

                const contentWrapper = document.querySelector('.wbetslip-modal-content');
                if (contentWrapper) {
                    contentWrapper.addEventListener('click', function (e) {
                        e.stopPropagation();
                    });
                }

            }, 300);
        }
    };

    function getSportsBonuses() {

        if (!window.altenarWSDK) {
            console.error('Altenar WSDK is not loaded.');
            return false;
        }

        if (!window.__altenar_initialized) {
            try {
                window.altenarWSDK.init({
                    integration: window.sportsbookData?.integration || 'betbeast',
                    culture: window.sportsbookData?.culture || 'en-GB',
                    token: window.sportsbookData?.token,
                });

                window.__altenar_initialized = true;
            } catch (e) {
                console.error('Altenar init failed:', e);
                return false;
            }
        }

        let bonusesBtn = document.querySelector('.button.sport-bonuses');

        if (!bonusesBtn) {
            return;
        }

        setTimeout(function(){

            bonusesBtn.classList.add('visible');

            let overlay = document.getElementById('wbetslip-overlay');
            if (!overlay) {
                overlay = document.createElement('div');
                overlay.id = 'wbetslip-overlay';
                overlay.className = 'bonuses';
                document.body.appendChild(overlay);
            }

            let container = document.getElementById('wbetslip-container');
            let isNew = false;

            if (!container) {
                isNew = true;

                container = document.createElement('div');
                container.id = 'wbetslip-container';
                container.className = 'wbetslip-container bonuses';
                container.setAttribute('role', 'dialog');
                container.setAttribute('aria-hidden', 'true');
                container.setAttribute('aria-modal', 'true');

                const closeBtn = document.createElement('button');
                closeBtn.className = 'wbetslip-close-btn';
                closeBtn.setAttribute('aria-label', 'Close modal');
                closeBtn.innerHTML = '<i class="fa fa-xmark" aria-hidden="true"></i>';

                const content = document.createElement('div');
                content.className = 'wbetslip-modal-content';
                content.id = 'wbetslip-modal-content';

                container.appendChild(closeBtn);
                container.appendChild(content);
                document.body.appendChild(container);

                closeBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    closeModal();
                });
            }

            const contentEl = document.getElementById('wbetslip-modal-content');

            function openModal() {

                const hasTouch =
                    'ontouchstart' in window || navigator.maxTouchPoints > 0;

                const maxSide = Math.max(window.innerWidth, window.innerHeight);
                const isMobileOrTablet = hasTouch && maxSide <= 1100;

                if (!window.altenarWSDK || !contentEl) return;

                contentEl.innerHTML = '';

                window.altenarWSDK.addWidget({
                    widget: 'WBonuses',
                    props: {},
                    container: contentEl
                });

                overlay.classList.add('open');
                container.classList.add('open');
                container.setAttribute('aria-hidden', 'false');

                document.documentElement.style.overflow = 'hidden';
                document.body.style.overflow = 'hidden';
            }

            function closeModal() {
                overlay.classList.remove('open');
                container.classList.remove('open');
                container.setAttribute('aria-hidden', 'true');

                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
            }


            if (isNew) {
                overlay.addEventListener('click', function (e) {
                    closeModal();
                    e.preventDefault();
                    return false;
                });

                if (contentEl) {
                    contentEl.addEventListener('click', function (e) {
                        e.stopPropagation();
                    });
                }
            }


            bonusesBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                openModal();
                return false;
            });

        },300);

    };

    setTimeout(function(){
        getSportsBetslip();
        getSportsBonuses();
    },300);

});
